export default __webpack_public_path__ + "static/media/ic_fantom_40.6f186921.png";